import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { Router } from '@angular/router';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { off } from 'process';
import { forkJoin } from 'rxjs';
import { GpsService } from 'src/app/services/core/gps/gps.service';
import { NearbyService } from 'src/app/services/core/nearby-service/nearby.service';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { TitleCasePipe } from '@angular/common';
@UntilDestroy()

@Component({
  selector: 'app-trips-distribution-modal',
  templateUrl: './trips-distribution-modal.component.html',
  styleUrls: ['./trips-distribution-modal.component.css']
})
export class TripsDistributionModalComponent implements OnInit,AfterViewInit {
  @Input() trips: any;
  @Input() preServiceAreas: any;
  companies: any = [];
  preAppointmentType: any;
  preSpacetypes: any;
  // preMembers: any;
  selectedCompany: any = null;
  companyDetail:any;
  selectedTrips:any;
  preCompanies:any = {}
  @Output() closeModal = new EventEmitter<any>();
  @Output() editTrip = new EventEmitter<any>();
  previousAssignedCompanies: any
  isSubmitted = false;
  status: any;
  action:any;
  search:any;
  search2:any
  levelofservices:any;
  preLevelOfService: any = {};
  thresholds: any;
  dashboardData: any;
  todayDate: string = new Date().toISOString(); // Default to today's date
  fareEstimation:any;
  tripsUniqueSpaceTypes: any;
  thresholdDashboard: any;
  totalMiles: any;
  tripsMilesBySaceType: any
  fareCalculation = {
    fundingSourceFare: 0,
    companyFare: 0,
    commission: 0,
  }
  thresholdsSpaceTypes: any;
  totalTripsCount: any; // excluse those whose spacetype doesn't fall in threshold spacetypes 
  threshold: any;
  tab = 'company';
  drivers:any = [];
  nearbyTab = 'normal';
  selectedEntity:any;
  showMap = false;
  @ViewChild(GoogleMap) map!: GoogleMap;
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  infoWindowRef: google.maps.InfoWindow | null = null;
  center: google.maps.LatLngLiteral = { lat: 37.7749, lng: -122.4194 };
  zoom = 5;
  allMarkers = new google.maps.MVCArray<google.maps.marker.AdvancedMarkerElement>();
  points:any = []
  selectedTrip: any;
  singleTrip:any
  

  constructor(
    private tripService: TripService,
    private companyService: CompanyService,
    private appointmentService: AppointmentTypeService,
    private configurationService: ConfigurationService,
    private spaceTypeService: SpaceTypeService,
    private memberService: MemberService,
    private router: Router,
    private levelOfService: LosService,
    private credentialService: CredentialService,
    private nearbyService: NearbyService
  ) {}

  ngOnInit(): void {
    const trips = JSON.parse(JSON.stringify(this.trips));
    this.trips = trips;
    if(this.trips){
      const checkedMemberId = this.trips[0]?.member?.id;
      if (this.trips.every((isTrip: any) => isTrip.member?.id === checkedMemberId)) {
        this.singleTrip = this.trips[0];
      } else {
        this.singleTrip = null;
      }
    }
    this.tripsUniqueSpaceTypes = _.uniq(this.trips.map((item: any) => item.spaceType));
    this.status = this.trips && this.trips.length ? this.trips[0].status : '';
    this.selectedTrips = this.trips.map((trip: any) => {
      return trip.id
    })
    // this.previousAssignedCompanies = this.trips.map((trip: any) => {
    //   return  trip.company && { company: trip.company, tripId: trip.id }
    // });
    this.previousAssignedCompanies = this.trips
      .filter((trip: any) => trip.company )
      .map((trip: any) => ({
        company: trip.company,
        trip: trip.id
      }));

    this.getAllAppointment();
    // this.getAllMembers();
    this.getAllCompanies();
    this.getSpaceType();
    this.getLevelOfService()

    const groupByTrips = this.trips.reduce((acc: any, trip: any) => {
      const formattedDate = moment(trip.pickup.time).format('D/M/YYYY');
      const spaceType = trip.spaceType;

      if (!acc[formattedDate]) {
        acc[formattedDate] = {
          title: [spaceType],
          trips: []
        };
      }

      acc[formattedDate].trips.push(trip);
      return acc;
    }, {});

    // this.getDashboardDetail();
    // this.getcompanythreshold()
  }

  ngAfterViewInit(): void {
    if (!this.map || !this.map.googleMap) {
      console.warn('Google Map not initialized yet');
      return;
    }
    this.map.googleMap.setOptions({
      mapId: '9fe6e06d06a9024ce7fa85b2',
    });
    setTimeout(() => this.setInitialBounds(), 300);

  }

  onShowMap(){
    this.showMap = !this.showMap
    setTimeout(() => this.setInitialBounds(), 300);
  }

  getAllCompanies() {
    const queryParams = {
      isActive: true,
      isApproved: true,
      limit: 9999
    };
    this.credentialService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preCompanies = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
        this.companies = data.results.map((company: any) => ({
          ...company,
          isSelected: false
        }));
        this.points = data.results.map((c: any) => {
          const coords = c.address?.coords?.length
            ? { lat: c.address.coords[1], lng: c.address.coords[0] }
            : null;
          return { id: c.id, name: c.name, profileImageURL: c.profileImageURL, email: c.email, coords };
        });
        this.clearMarkers();
        this.addMarkers(this.points);
      }
    });
  }

  getAllDrivers() {
    let queryParams = {
      limit: 9999,
      isActive: true,
      isApproved: true
    }
    this.credentialService.getPickerDrivers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.drivers = data.results.filter((item:any)=>{
          if (item.company && this.preCompanies[item.company]){
            const driverCompany = this.preCompanies[item.company]
            if(driverCompany.isActive && driverCompany.isApproved){
              return item;
            }
          }
        })
        this.points = this.drivers.map((c: any) => {
          const coords = c.address?.coords?.length
            ? { lat: c.address.coords[1], lng: c.address.coords[0] }
            : null;
          return { id: c.id, name: c.firstName + ' ' + c.lastName, profileImageURL: c.profileImageURL, email: c.email, coords };
        });
        this.clearMarkers();
        this.addMarkers(this.points);
      }
    })
  }

  getAllAppointment() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.appointmentService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results ) {
        this.preAppointmentType = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getSpaceType() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preSpacetypes = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  // getAllMembers() {
  //   this.memberService.getMembers({limit:999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data && data.results ) {
  //       this.preMembers = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
  //     }
  //   });
  // }

  getDashboardDetail() {
    const companyId = this.selectedEntity?.type === 'company' ? this.selectedEntity.id : this.selectedEntity?.company
    this.configurationService.getDashboardDetails(companyId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.companyDetail = {drivers:data.drivers, vehicles:data.vehicles};
      }
    })
  }

  getCompanyThreshold() {
    const queryParams = {
      isActive: true,
      time: this.trips[0].pickup.time,
      spaceType: this.tripsUniqueSpaceTypes
    }

    const payload = {
      company: this.selectedEntity?.type === 'company' ? this.selectedEntity.id : this.selectedEntity?.company,
    }
    return this.credentialService.getCompanyThreshold(payload,queryParams);
  }

  onSelectCompany(company: any) {
    if (!company) return;
    this.companies = this.companies.map((c: any) => ({
      ...c,
      isSelected: c === company ? !c.isSelected : false
    }));
    const selected = this.companies.find((c: any) => c.isSelected) || null;
    this.clearMarkers();
    if(selected){
      const companyPoints = this.points.filter((p: any) => p.id === (selected && selected.id));
      this.addMarkers(companyPoints);
      // this.fitBounds(companyPoints);
    }else{
      this.addMarkers(this.points);
    }
    this.selectedEntity = selected
      ? { ...selected, type: 'company' }
      : null;

    if (this.selectedEntity) {
      this.getDashboardDetail();
      this.getThresholdAndFare();
      this.setSelectedEntityBounds();
    } else {
      this.setInitialBounds();
    }
  }

  onSelectDriver(driver: any) {
    if (!driver) return;
    this.drivers = this.drivers.map((d: any) => ({
      ...d,
      isSelected: d === driver ? !d.isSelected : false
    }));
    const selected = this.drivers.find((d: any) => d.isSelected) || null;
    this.clearMarkers();
    if (selected) {
      const driverPoints = this.points.filter((p: any) => p.id === (selected && selected.id));
      this.addMarkers(driverPoints);
      // this.fitBounds(driverPoints);
    } else {
      this.addMarkers(this.points);
    }


    this.selectedEntity = selected
      ? { ...selected, type: 'driver' }
      : null;

    if (this.selectedEntity) {
      this.getDashboardDetail();
      this.getThresholdAndFare();
      this.setSelectedEntityBounds();
    } else {
      this.setInitialBounds();
    }
  }


  getThresholdAndFare() {
    forkJoin({
      fareEstimation: this.getFareEstimation(),
      threshold: this.getCompanyThreshold(),
    }).pipe(untilDestroyed(this))
      .subscribe(({ fareEstimation, threshold }: any) => {

        if (fareEstimation) {
          this.fareEstimation = fareEstimation;
          this.calculateForecast();
        }

        if (threshold) {
          this.threshold = threshold;
          this.calculateNewThreshold();
        }
      });
  }

  calculateNewThreshold() {
    const { thresholds, thresholdDashboard } = this.threshold;
    this.thresholdsSpaceTypes = thresholds.map((threshold: any) => threshold.spaceType._id);
    this.groupTripsBySpaceType(this.thresholdsSpaceTypes);
    this.calculateTotals(this.thresholdsSpaceTypes);
    this.thresholdDashboard = thresholdDashboard.reduce((acc: any, item: any) => {
      const spaceTypeId = item.spaceType._id;
      acc[spaceTypeId] = item;
      return acc;
    }, {});

    thresholds.forEach((threshold: any) => {
      const spaceTypeId = threshold.spaceType._id;
      const dashboard = this.thresholdDashboard[spaceTypeId];
      const newTotals = this.tripsMilesBySaceType[spaceTypeId];

      const consumedMiles: any = {
        now: dashboard?.consumedMiles || 0,
        percentage: (((dashboard?.consumedMiles || 0) / (threshold.miles || 0)) || 0) * 100
      }
      const consumedTrips: any = {
        now: dashboard?.consumedTrips || 0,
        percentage: (((dashboard?.consumedTrips || 0) / (threshold.trips || 0)) || 0) * 100
      };
      const consumedAmount: any = {
        now: dashboard?.consumedAmount || 0,
        percentage: (((dashboard?.consumedAmount || 0) / (threshold.amount || 0)) || 0) * 100
      };

      if (newTotals) {
        // Miles
        consumedMiles['new'] = newTotals.totalMiles;
        consumedMiles['isExceeded'] = (consumedMiles.now + consumedMiles.new) > (threshold.miles || 0);
        consumedMiles['newPercentage'] = (consumedMiles.new / threshold.miles) * 100;

        // Trips
        consumedTrips['new'] = newTotals.totalTrips;
        consumedTrips['isExceeded'] = (consumedTrips.now + consumedTrips.new) > (threshold.trips || 0);
        consumedTrips['newPercentage'] = (consumedTrips.new / threshold.trips) * 100;

        console.log(consumedAmount.now, consumedAmount.new)
        // Amount
        consumedAmount['new'] = newTotals.totalAmount;
        consumedAmount['isExceeded'] = (consumedAmount.now + consumedAmount.new) > (threshold.amount || 0);
        consumedAmount['newPercentage'] = (consumedAmount.new / threshold.amount) * 100;
      }

      threshold['consumedMiles'] = consumedMiles;
      threshold['consumedTrips'] = consumedTrips;
      threshold['consumedAmount'] = consumedAmount;
    });
    this.thresholds = thresholds;
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  async assign() {
    this.isSubmitted = true;

    if (!(this.selectedEntity && this.trips && this.trips.length)) {
      return;
    }

    const isAllowExceed = await this.isAnyThresholdExceed();
    if (!isAllowExceed) {
      return;
    }

    if (this.isViolationExist()) {
      sweetAlert('Alert', 'A service area violation exists. Do you want to proceed?', 'warning', 'OK', 'Cancel')
        .then((result) => {
          if (result.isConfirmed) {
            this.distribute();
          }
        });
    } else {
      this.distribute();
    }
  }

  async isAnyThresholdExceed() {
    let blnReturn = true;
    const exceededSpaceTypes = this.thresholds.filter((threshold: any) =>
      threshold.consumedMiles?.isExceeded ||
      threshold.consumedTrips?.isExceeded ||
      threshold.consumedAmount?.isExceeded
    ).map((threshold: any) => threshold.spaceType.title);
    if (exceededSpaceTypes && exceededSpaceTypes.length) {
      const result = await sweetAlert('Alert', `Threshold exceeded of Space Types: ${exceededSpaceTypes.toString()}. Do you wish to continue?`, 'warning', 'Yes', 'No');
      if (!result.value) blnReturn = false;
    }
    return blnReturn;
  }

  isViolationExist() {
    const companyServiceAreas = this.selectedEntity?.type === 'company' ? this.selectedEntity.serviceAreas : null;

    if (!(companyServiceAreas && companyServiceAreas.length)) {
      return false;
    }

    const tripsServiceAreas = Array.from(
      new Set(this.trips.map((trip: any) => trip.serviceArea))
    );

    return !tripsServiceAreas.every(serviceArea => companyServiceAreas.includes(serviceArea));
  }

  async distribute() {
    const result = await sweetAlert(
      "Alert",
      "Are you sure you want to assign trip",
      "warning",
      "Yes",
      "No"
    );
    if (!result.value) return;
    
    const newSelectedTrips = this.trips.reduce((acc: any[], trip: any) => {
      if(trip.company){
        if (trip.company === this.selectedEntity?.company || trip.company === this.selectedEntity?.id) {
          acc.push(trip.id);
        }
      }
      return acc;
    }, []);

    // if (newSelectedTrips.length) {
    //   const warningResult = await sweetAlert(
    //     "Alert",
    //     "Trips already assigned to same company.",
    //     "warning",
    //     "OK"
    //   );
    //   if (warningResult.isConfirmed) return;
    // }

    const pre = this.previousAssignedCompanies.filter(
      (trip: any) => trip.company !== this.selectedEntity?.company
    );

    const selectedIds = this.trips.map(
      (trip: any) => trip.id
    );

    const payload: any = {
      pre,
      selectedIds,
      status: "offered"
    };

    if (this.selectedEntity?.type === 'company') {
      payload.company = this.selectedEntity.id;
    }
    if (this.selectedEntity?.type === 'driver') {
      payload.driver = this.selectedEntity.id;
      payload.company = this.selectedEntity.company; // driver carries company
    }

    this.action = 'assign';
    this.apiRequest(payload);
  }


  unassign() {
    sweetAlert(
      "Alert",
      "Are you sure you want to unassign trip",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload: any = {
          pre: this.previousAssignedCompanies,
          selectedIds: this.selectedTrips,
          company: null,
          driver: null,
          status: "scheduled"
        };
        this.action = 'unassign';
        this.apiRequest(payload);
      }
    });
  }

  apiRequest(payload: any) {
    this.tripService.assignToCompany(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res:any) => {
        if (res) {

          if (res) {
            const { skippedTrips, message } = res.statusUpdate;
            const processedTrips = skippedTrips && skippedTrips.length ? this.selectedTrips.filter((tripId: any) => !skippedTrips.includes(tripId)) : this.selectedTrips;
            this.editTrip.emit({
              tripsIds: processedTrips,
              company: this.selectedEntity?.type === 'company' ? this.selectedEntity.id : this.selectedEntity?.company,
              source: this.action
            });
            if (skippedTrips && skippedTrips.length) {
              const html = this.getSkippedTripsHtml(skippedTrips, message);
              sweetAlertWithHtml("Alert", "This is a sample message", "alert", "OK", html);
            } else {
              sweetAlert("Alert", res.statusUpdate.message, "alert", "OK");
            }
          }

         
        }
      }
    },)
  }

  getLevelOfService() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.levelOfService.getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.levelofservices = data.results;
          this.preLevelOfService = this.levelofservices.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getFareEstimation(){
    const payload = {
      trips : this.selectedTrips,
      company: this.selectedEntity?.type === 'company' ? this.selectedEntity.id : this.selectedEntity?.company
    };

    return this.credentialService.getFareEstimation(payload);
  }

  calculateComission(fare: any, specialRate: any, offeredFare: any) {

    let commission = 0;

    if (specialRate > 0) {
      commission = fare - specialRate;
    } else {
      commission = fare - offeredFare;
    }
    return commission;
  }

  getNewMiles(thresholdMiles: any, spaceTypeId: any) {
    if (this.tripsMilesBySaceType && this.tripsMilesBySaceType[spaceTypeId]
      && this.thresholdDashboard && this.thresholdDashboard[spaceTypeId]
    ) {
      const newConsumedMiles = this.thresholdDashboard[spaceTypeId].consumedMiles + this.tripsMilesBySaceType[spaceTypeId].totalMiles;
      return {
        isExceeded: newConsumedMiles > thresholdMiles ? true : false,
        newMiles: this.tripsMilesBySaceType[spaceTypeId].totalMiles
      }
    }
    return;
  }

  getNewTripsCount(thresholdTotalTrips: any, spaceTypeId: any) {
    if (this.tripsMilesBySaceType && this.tripsMilesBySaceType[spaceTypeId]
      && this.thresholdDashboard && this.thresholdDashboard[spaceTypeId]
    ) {
      const newConsumedTrips = this.thresholdDashboard[spaceTypeId].consumedTrips + this.tripsMilesBySaceType[spaceTypeId].totalTrips;
      return {
        isExceeded: newConsumedTrips > thresholdTotalTrips ? true : false,
        newTripsCount: this.tripsMilesBySaceType[spaceTypeId].totalTrips
      }
    }
    return;
  }

  getNewAmount(thresholdTotalAmount: any, spaceTypeId: any) {
    if (this.tripsMilesBySaceType && this.tripsMilesBySaceType[spaceTypeId]
      && this.thresholdDashboard && this.thresholdDashboard[spaceTypeId]
    ) {
      const newConsumedAmount = this.thresholdDashboard[spaceTypeId].consumedAmount + this.tripsMilesBySaceType[spaceTypeId].totalAmount;
      return {
        isExceeded: newConsumedAmount > thresholdTotalAmount ? true : false,
        newAmount: this.tripsMilesBySaceType[spaceTypeId].totalAmount
      }
    }
    return;
  }

  calculateForecast() {
    this.fareCalculation = {
      fundingSourceFare: 0,
      companyFare: 0,
      commission: 0,
    };
    for (let item of this.trips) {

      let fare = item.fare?.total || 0;
      if(item.preSpecialRate && item.preSpecialRate > 0){
        fare = item.preSpecialRate;
      }
      let offered = 0;

      if (item.specialRate && item.specialRate > 0) {
        offered = item.specialRate;
      } else {
        offered = this.fareEstimation[item.id]?.breakdown?.total || 0;
      }

      this.fareCalculation.fundingSourceFare += fare;
      this.fareCalculation.companyFare += offered;
      this.fareCalculation.commission += (fare - offered);
    }
  }

  getMilesPercentages(thresholdMiles: any, spaceTypeId: any) {
    if (this.tripsMilesBySaceType && this.tripsMilesBySaceType[spaceTypeId]
      && this.thresholdDashboard && this.thresholdDashboard[spaceTypeId]
    ) {
      const currentPercentage = (this.thresholdDashboard[spaceTypeId].consumedMiles / thresholdMiles) * 100;
      const suggestedPercentage = (this.tripsMilesBySaceType[spaceTypeId].totalMiles / thresholdMiles) * 100;
      return {
        currentPercentage: currentPercentage,
        suggestedPercentage: suggestedPercentage
      }
    }
    return {};
  }

  getTripsPercentages(thresholdTrips: any, spaceTypeId: any) {
    if (this.tripsMilesBySaceType && this.tripsMilesBySaceType[spaceTypeId]
      && this.thresholdDashboard && this.thresholdDashboard[spaceTypeId]
    ) {

      const currentPercentage = (this.thresholdDashboard[spaceTypeId].consumedTrips / thresholdTrips) * 100;
      const suggestedPercentage = (this.tripsMilesBySaceType[spaceTypeId].totalTrips / thresholdTrips) * 100;
      return {
        currentPercentage: currentPercentage,
        suggestedPercentage: suggestedPercentage
      }
    }
    return {};
  }

  getAmountPercentages(thresholdAmount: any, spaceTypeId: any) {
    if (this.tripsMilesBySaceType && this.tripsMilesBySaceType[spaceTypeId]
      && this.thresholdDashboard && this.thresholdDashboard[spaceTypeId]
    ) {

      const currentPercentage = (this.thresholdDashboard[spaceTypeId].consumedAmount / thresholdAmount) * 100;
      const suggestedPercentage = (this.tripsMilesBySaceType[spaceTypeId].totalAmount / thresholdAmount) * 100;
      return {
        currentPercentage: currentPercentage,
        suggestedPercentage: suggestedPercentage
      }
    }
    return {};
  }

  removeTrip(index: number) {
    if (index > -1 && index < this.trips.length) {
      this.trips.splice(index, 1);
    }
    this.selectedTrips = this.trips.map((trip: any) => trip.id);
    if (this.selectedEntity) {
      this.calculateForecast();
      this.calculateTotals(this.thresholdsSpaceTypes);
      // this.groupTripsBySpaceType(this.thresholdsSpaceTypes);
      this.calculateNewThreshold()
    }
  }

  calculateTotals(thresholdsSpaceTypes: any) {
    this.totalMiles = this.trips
      .filter((trip: any) => thresholdsSpaceTypes.includes(trip.spaceType))
      .reduce((sum: number, trip: any) => sum + (trip.miles || 0), 0);
    // this.totalMiles = this.trips.reduce((sum: any, trip: any) => sum + (trip.miles || 0), 0);
    this.totalTripsCount = this.trips.filter((trip: any) => thresholdsSpaceTypes.includes(trip.spaceType)).length;
  }

  groupTripsBySpaceType(thresholdsSpaceTypes: any) {
    this.tripsMilesBySaceType = this.trips
      .filter((trip: any) => thresholdsSpaceTypes.includes(trip.spaceType))
      .reduce((acc: any, item: any) => {
        const spaceTypeId = item.spaceType;
        const distance = item.miles || 0; // ensure distance is a number
        let offeredFare = this.fareEstimation
          && this.fareEstimation[item.id]
          && this.fareEstimation[item.id].breakdown ? this.fareEstimation[item.id].breakdown.total : 0

        if (item.specialRate && item.specialRate > 0) {
          offeredFare = item.specialRate;
        }
        // if (item.preSpecialRate && item.preSpecialRate > 0) {
        //   item.fare.total = item.preSpecialRate;
        // }
        
        if (!acc[spaceTypeId]) {
          acc[spaceTypeId] = {
            totalTrips: 0,
            totalMiles: 0,
            totalAmount: 0
          };
        }

        acc[spaceTypeId].totalTrips += 1;
        acc[spaceTypeId].totalMiles += distance;
        acc[spaceTypeId].totalAmount += offeredFare;

        return acc;
      }, {});
  }

  setTab(tab: string) {
    this.tab = tab;
    this.points = [];
    this.clearMarkers();
    if(tab === 'company'){
      this.getAllCompanies();
      this.drivers = [];
    }else{
      this.getAllDrivers();
      this.companies = [];
    }
    this.selectedEntity = null;
    this.fareEstimation = null;
    this.threshold = null;
    this.fareCalculation = {
      fundingSourceFare: 0,
      companyFare: 0,
      commission: 0,
    }
  }

  getNearbyDrivers(){
    this.drivers = [];
    const queryParams = {
      limit: 9999,
      latitude: this.trips[0].pickup.address.coords[1],
      longitude: this.trips[0].pickup.address.coords[0],
    }
    this.nearbyService.getNearbyDrivers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        for (let item of data) {
          if (item.driver) {
            this.drivers.push({ ...item.driver, company: item.company });
          }
        }
      }
    })
  }

  setNearbyTab(tab: string) {
    this.nearbyTab = tab;
    if (this.nearbyTab === 'nearby') {
      this.getNearbyDrivers();

    } else {
      this.drivers = [];
      this.getAllDrivers();
    }
    this.selectedEntity = null;
    this.fareEstimation = null;
    this.threshold = null;
    this.fareCalculation = {
      fundingSourceFare: 0,
      companyFare: 0,
      commission: 0,
    }
  }

  clearMarkers() {
    this.allMarkers.forEach(marker => (marker.map = null));
    this.allMarkers.clear();
  }

  getMarkerContent(entity: any): string {
    const size = entity.company ? 'w-10 h-10' : 'w-12 h-12';
    return `
      <div>
        <div class="${size} rounded-full overflow-hidden border-2 border-gray-300 shadow-md">
          <img src="${entity.profileImageURL || 'assets/images/profileImagePlaceholder.png'}"
               alt="${entity.name}" class="w-full h-full object-cover"/>
        </div>
      </div>`;
  }

  getInfoWindowContent(entity: any): string {
    return `
      <div>
        <p><span class="font-semibold">Name:</span> ${entity.name}</p>
        <p><span class="font-semibold">Email:</span> ${entity.email}</p>
        ${entity.company && this.preCompanies[entity.company]
        ? `<p><span class="font-semibold">Company:</span> ${this.preCompanies[entity.company].name}</p>`
        : ''}
      </div>`;
  }

  addMarkers(points: any[]) {
    if (!points?.length) return;
    points.forEach((point: any) => {
      if (!point.coords) return;

      const markerElement = document.createElement('div');
      markerElement.innerHTML = this.getMarkerContent(point);

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map.googleMap,
        position: point.coords,
        content: markerElement,
        title: point.name
      });

      this.allMarkers.push(marker);

      const infoWindow = new google.maps.InfoWindow({
        content: this.getInfoWindowContent(point)
      });

      marker.addListener('click', () => {
        if (this.infoWindowRef) this.infoWindowRef.close();
        this.infoWindowRef = infoWindow;
        infoWindow.open({ anchor: marker, map: this.map.googleMap });
      });
    });
  }

  openInfo(marker: MapMarker, trip: any) {
    this.selectedTrip = trip;
    this.infoWindow.open(marker);
  }



  setInitialBounds() {
    if (!this.map || !this.map.googleMap) return;
    const bounds = new google.maps.LatLngBounds();

    (this.trips || []).forEach((trip: any) => {
      const pickup = trip.pickup?.address?.coords;
      const dropoff = trip.dropoff?.address?.coords;
      if (pickup?.length === 2) bounds.extend({ lat: pickup[1], lng: pickup[0] });
      if (dropoff?.length === 2) bounds.extend({ lat: dropoff[1], lng: dropoff[0] });
    });

    (this.points || []).forEach((p: any) => {
      if (p.coords) bounds.extend(p.coords);
    });

    if (!bounds.isEmpty()) this.map.googleMap.fitBounds(bounds);
  }

  setSelectedEntityBounds() {
    if (!this.map || !this.map.googleMap || !this.selectedEntity) return;
    const bounds = new google.maps.LatLngBounds();

    const entityPoint = this.points.find((p: any) => p.id === this.selectedEntity.id);
    if (entityPoint?.coords) bounds.extend(entityPoint.coords);

    (this.trips || []).forEach((trip: any) => {
      const pickup = trip.pickup?.address?.coords;
      const dropoff = trip.dropoff?.address?.coords;
      if (pickup?.length === 2) bounds.extend({ lat: pickup[1], lng: pickup[0] });
      if (dropoff?.length === 2) bounds.extend({ lat: dropoff[1], lng: dropoff[0] });
    });

    if (!bounds.isEmpty()) this.map.googleMap.fitBounds(bounds);
  }


    getSkippedTripsHtml(skippedTripsIds: any, message: any) {
      const skippedTrips = this.trips.filter((trip: any) => skippedTripsIds.includes(trip.id))
      let html = `<p class="mb-4">${message}</p><div
      class="max-h-[400px] overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
      <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
        <div class="flow-root h-full overflow-y-auto">
          <div class="-my-2">
            <div class="inline-block min-w-full py-2 align-middle">
              <table class="min-w-full border-separate border-spacing-0">
                <thead>
                  <tr>
                     <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Member
                    </th>
                    <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Reference ID
                    </th>
                  </tr>
                </thead>
                <tbody>`;
      skippedTrips.forEach((trip: any) => {
        html += `
                  <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                    <td class="px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                     ${trip?.member?.displayName ? new TitleCasePipe().transform(trip?.member?.displayName) : ''}
                    </td>
                    <td class="px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                     ${trip.reference}${trip.suffix ? '-'+trip.suffix : ''}
                    </td>
                  </tr>
                  `;
      });
      html += `
                </tbody>
              </table>
              </div>
              </div>
              </div>
              </div>
              </div>
              <p class="mt-2">You may update fare/threshold and try for these trips later.</p>
              `
      return html;
    }



}
